import './styles/ErrorFallback.scss';

import { SentimentDissatisfied } from '@mui/icons-material';
import { Grid, Paper } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { isProduction } from 'utils';

import { translations } from 'locales/i18n';

interface Props {
  error: unknown;
  resetError?: () => void;
  componentStack: string | null;
}

export function ErrorFallback(props: Props) {
  const { t } = useTranslation();

  return (
    <Grid container component={Paper} className="error-fallback">
      <Grid container justifyContent="center" className="error-fallback__icon">
        <SentimentDissatisfied />
      </Grid>
      <Grid container className="error-fallback__message">
        <Grid item xs>
          {!isProduction() && props.error instanceof Error
            ? props.error.message
            : t(translations.common.genericError())}
        </Grid>
      </Grid>
      {!isProduction() && (
        <Grid container>
          <pre>{props.componentStack}</pre>
        </Grid>
      )}
    </Grid>
  );
}
